import * as Logger from 'loglevel';
import * as signalR from "@microsoft/signalr";
import * as FtnOpCope from './FtnOpCode';
import * as ActionType from '../ActionType';

export const createHubFtnClientMiddleware = (url) => {

    return (store) => {
        let connection = new signalR.HubConnectionBuilder()
            .withUrl(url)
            .withAutomaticReconnect()
            .build();

        connection.on("onFtnReceived", (message) => {
            Logger.debug(`FTN Received`, message)
            let ftn = JSON.parse(message);
            Logger.debug(`FTN =`, ftn)
            Logger.debug(`store =`, store)
            let actionType = null;
            switch (ftn.opCode) {
                case FtnOpCope.FTN_UPDATE_PERMISSION:
                    actionType = ActionType.FTN_UPDATE_PERMISSION;
                    break;
                case FtnOpCope.FTN_DELETE_PERMISSION:
                    actionType = ActionType.FTN_DELETE_PERMISSION;
                    break;
                case FtnOpCope.FTN_ADD_PERMISSION:
                    actionType = ActionType.FTN_ADD_PERMISSION;
                    break;
                case FtnOpCope.FTN_ADD_FOLDER:
                    actionType = ActionType.FTN_ADD_FOLDER;
                    break;
                case FtnOpCope.FTN_DELETE_FOLDER:
                    actionType = ActionType.FTN_DELETE_FOLDER;
                    break;
                case FtnOpCope.FTN_UPDATE_FOLDER:
                    actionType = ActionType.FTN_UPDATE_FOLDER;
                    break;
                default:
                    break;
            }

            Logger.debug(`actionType =`, actionType)
            try {
                if (!!actionType) {
                    store.dispatch({
                        type: actionType,
                        payload: ftn.content
                    });
                    Logger.debug(`FTN action ${actionType} dispatched`);
                }
                else {
                    Logger.error(`FTN ignored: no action type!`);
                }
            }
            catch (error) {
                Logger.error(`Ftn error: ${error}`);
            }

            Logger.debug(`Ftn Processed`)
        });
        connection.start().then(() => {
            Logger.debug("FolderHubClient connected");
        }).catch((error) => {
            console.error("Error starting FolderHubClient:", error);
        });

        return next => action => {
            var result = next(action)
            return result;
        };
    }
}

